module.exports = " <main class=app> <top :title=title></top> <view></view> <grid :columns.sync=columns></grid> <symbols></symbols> </main> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 725
// module chunks = 2